import React from "react";

import { Grid } from "@mui/material";

import { Strong, Text } from "../components";
import useStyles from "../styles";

const MARGIN_SIZE = "16px";

export const PrivacyPolicyPageAU = () => {
  const classes = useStyles();

  return (
    <React.Fragment>
      <Grid item>
        <Text>
          Shipeezi has a legal obligation to comply with all applicable legislation affecting its
          business operations, and every employee must play their part in meeting these
          requirements, in areas such data privacy, intellectual property, and governance.
        </Text>
      </Grid>

      <Grid item marginY={MARGIN_SIZE}>
        <Strong>Our Privacy Policy was last updated in 2022.</Strong>
        <br />
        <br />
        <Text>
          At Shipeezi we take privacy very seriously. We have developed this Privacy Policy to
          ensure we communicate with our customers, in the clearest way possible, the manner in
          which we collect, use, store and disclose Personal Information. We encourage you to read
          this Privacy Policy carefully. It will help customers make informed decisions about
          sharing Personal Information with us.
        </Text>
        <br />
        <Text>In this Privacy Policy, references to:</Text>
        <br />
        <br />
        <Text>
          {"a)"} <Strong>“We”, </Strong>
          <Strong>“us”</Strong> and <Strong>“our”</Strong> means Shipeezi Pty Ltd ACN 633 689 764;
          and
        </Text>
        <br />
        <Text>
          {"b)"} <Strong>“I”</Strong>, <Strong>“You”</Strong>, <Strong>“Your”</Strong> and{" "}
          <Strong>“Customer”</Strong> are references to a user of the Shipeezi Services and products
          (including the Shipeezi website) or who otherwise provide us with Personal Information.
        </Text>
        <br />
        <br />
        <Text>
          The defined terms which are not defined in this Privacy Policy have the same meaning as in
          the Shipeezi website Terms of Use. By accessing the Shipeezi website and using the
          Services, you consent to us collecting, holding, using, and disclosing your Personal
          Information in accordance with this Privacy Policy.
        </Text>
      </Grid>

      <Grid item marginBottom={MARGIN_SIZE}>
        <Strong>What is Personal Information?</Strong>
        <br />
        <Text>
          Shipeezi provides services and products, including the provision of the Shipeezi website
          (the <Strong>&quot;Service&quot;</Strong> or <Strong>&quot;Services&quot;</Strong>
          ), which may result in us collecting your Personal Information. The provision of the
          Services may involve the collection, use, disclosure and/or storage of data about a
          company or individual. That data can include Personal Information.{" "}
          <Strong>&quot;Personal Information&quot;</Strong> is any information or an opinion about
          an identified individual or an individual who can be reasonably identified from the
          information or opinion. Information or an opinion may be Personal Information regardless
          of whether it is true.
        </Text>
      </Grid>

      <Grid item marginBottom={MARGIN_SIZE}>
        <Strong>What Personal Information do we collect and hold?</Strong>
        <br />
        <Text>
          Shipeezi may collect Personal Information directly from you when you:
          <br />
          <br />
          <ul className={classes.tag}>
            <li>create an account on a Shipeezi Site or register to use a Service;</li>
            <li>use a Service;</li>
            <li>contact the Shipeezi support team; or</li>
            <li>or visit the Shipeezi website.</li>
          </ul>
        </Text>
        <Text>
          Customers can always choose not to provide Personal Information to Shipeezi, but it may
          mean that we are unable to provide them with all or part of a Service. The information we
          collect from you may include your identity and contact details, your history of purchases,
          your use of the Services, the commercial terms of your use of the Services, and details of
          enquiries or complaints you make.
        </Text>
        <br />
        <br />
        <Text>
          We may collect information about how you access, use and interact with the website. We do
          this by using a range of tools such as Google Analytics. Microsoft Clarity and Hubspot.
          This information may include:
          <br />
          <br />
          <ul className={classes.tag}>
            <li>
              the location from which you have come to the site and the pages you have visited; and
            </li>
            <li>
              technical data, which may include IP address, the types of devices you are using to
              access the website, device attributes, browser type, language and operating system.
            </li>
          </ul>
        </Text>
      </Grid>

      <Grid item marginBottom={MARGIN_SIZE}>
        <Strong>Shipeezi uses cookies</Strong>
        <br />
        <Text>
          In providing the Services, Shipeezi utilises “cookies”. A cookie is a small text file that
          is stored on a browser&lsquo;s computer for record-keeping purposes. A cookie does not
          identify browsers personally or contain any other information about them, but it does
          identify their computer.
        </Text>
        <br />
        <br />
        <Text>
          We and some of our affiliates and third-party service providers may use a combination of
          “persistent cookies” (cookies that remain on a browser’s hard drive for an extended period
          of time) and “session ID cookies” (cookies that expire when closing the browser) on the
          Shipeezi website to, for example, track overall site usage, and track and report on your
          use and interaction with ad impressions and ad services.
        </Text>
        <br />
        <br />
        <Text>
          Browsers can set their browser to notify themselves when they receive a cookie so that
          they will have an opportunity to either accept or reject it in each instance. However,
          browsers should note that refusing cookies may have a negative impact on the functionality
          and usability of the Services.
        </Text>
      </Grid>

      <Grid item marginBottom={MARGIN_SIZE}>
        <Strong>Why do we collect, hold and use your Personal Information?</Strong>
        <br />
        <Text>
          Shipeezi collects, holds, and uses your Personal Information for limited purposes.
        </Text>
        <br />
        <br />
        <Text>
          Shipeezi collects Personal Information so that we can provide you with the Services and
          any related Services you may request. In doing so, Shipeezi may use the Personal
          Information we have collected from customers to provide the Services and for purposes
          related to the Services including:
        </Text>
        <br />
        <br />
        <Text>
          <ul className={classes.tag}>
            <li>verifying identity;</li>
            <li>administering the Service;</li>
            <li>notifying customers of new Services or changes to existing Services;</li>
            <li>carrying out marketing or training relating to a Service;</li>
            <li>
              assisting with the resolution of technical support issues or other issues relating to
              the Services;
            </li>
            <li>complying with laws and regulations in applicable jurisdictions;</li>
            <li>
              communicating with customers about the Services and about Shipeezi generally; and
            </li>
            <li>any other purposes reasonably connected to any of the foregoing.</li>
          </ul>
        </Text>
        <Text>
          {" "}
          By using a Service, you consent to your Personal Information being collected, held and
          used in this way. Shipeezi will seek your consent in respect of any use not expressly set
          out in this Privacy Policy.
        </Text>
      </Grid>

      <Grid item marginBottom={MARGIN_SIZE}>
        <Strong>How do we collect your Personal Information?</Strong>
        <br />
        <Text>
          In addition to the methods of collection described above, we may collect data:
          <br />
          Shipeezi may receive Personal Information from customers about others.
        </Text>
        <br />
        <br />
        <Text>
          Through customer use of the Service, Shipeezi may also collect information from customers
          about someone else (such as a client or service provider). If customers provide Shipeezi
          with Personal Information about someone else, they must ensure that they are authorised to
          disclose that information to Shipeezi and that, without Shipeezi taking any further steps
          required by applicable data protection or privacy laws, Shipeezi may collect, use and
          disclose such information for the purposes described in this Privacy Policy.˝
        </Text>
        <br />
        <br />
        <Text>
          This means that customers must take reasonable steps to ensure the individual concerned is
          aware of and/or consents to the various matters detailed in this Privacy Policy, including
          the fact that their Personal Information is being collected, the purposes for which that
          information is being collected, the intended recipients of that information, the
          individual’s right to obtain access to that information, Shipeezi’s identity, and how to
          contact Shipeezi.
        </Text>
        <br />
        <br />
        <Text>
          When requested to do so by Shipeezi, customers must also assist Shipeezi with any requests
          by the individual to access or update the Personal Information customers have collected
          from them and disclosed to Shipeezi.
        </Text>
      </Grid>

      <Grid item marginBottom={MARGIN_SIZE}>
        <Strong>Shipeezi can aggregate customers’ non-personally identifiable data</Strong>
        <br />
        <Text>
          By using a Service, customers agree that Shipeezi can access, aggregate and use
          non-personally identifiable data Shipeezi has collected from customers and can manually
          de-identify Personal Information to create a non-personally identifiable dataset. This
          data will in no way identify customers or any other individual.
        </Text>
        <br />
        <br />
        <Text>Shipeezi may use this aggregated non-personally identifiable data to:</Text>
        <br />
        <br />
        <Text>
          <ul className={classes.tag}>
            <li>assist us to better understand how our customers are using the Services;</li>
            <li>
              provide our customers with further information regarding the uses and benefits of the
              Services;
            </li>
            <li>
              enhance business productivity, including by creating useful business insights from
              that aggregated data and allowing customers to benchmark their business’ performance
              against that aggregated data; and otherwise to improve the Services.
            </li>
          </ul>
        </Text>
      </Grid>

      <Grid item marginBottom={MARGIN_SIZE}>
        <Strong>How do we store and hold Personal Information?</Strong>
        <br />
        <Text>Shipeezi holds your Personal Information on servers located in Australia.</Text>
        <br />
        <br />
        <Text>
          All data, including Personal and non-Personal Information, that is entered into the
          Service by customers, or automatically imported on their instruction, is transferred to
          Shipeezi’s servers as a function of transmission across the internet. By using the
          Service, customers consent to their Personal Information being transferred to our servers
          as set out in this Privacy Policy.
        </Text>
        <br />
        <br />
        <Text>
          Currently our servers are located in the cloud, hosted primarily by AWS. Customers’
          Personal Information will be routed through, and stored on, those servers as part of the
          Service. If the location of our servers changes in the future, we will update this Privacy
          Policy. Customers should review our Privacy Policy regularly to keep informed of any
          updates.˝
        </Text>
        <br />
        <br />
        <Text>
          By providing Personal Information to Shipeezi, customers consent to Shipeezi storing your
          Personal Information on servers hosted in Australia. While Personal Information will be
          stored on servers located in Australia, it will remain within Shipeezi’s effective control
          at all times. The server host’s role is limited to providing a hosting and storage service
          to Shipeezi, and we’ve taken steps to ensure that our server hosts do not have access to,
          and use the necessary level of protection for, customers’ Personal Information.
        </Text>
      </Grid>

      <Grid item marginBottom={MARGIN_SIZE}>
        <Strong>Shipeezi takes steps to protect Personal Information</Strong>
        <br />
        <Text>
          Shipeezi is committed to protecting the security of Personal Information and we take all
          reasonable precautions to protect it from unauthorised access, modification or disclosure.
          These precautions include:
        </Text>
        <br />
        <br />
        <Text>
          <ul className={classes.tag}>
            <li>
              Personal information is stored on secure servers that have SSL Certificates issued by
              leading certificate authority Trustwave, and all data transferred between you and the
              Services is encrypted;
            </li>
            <li>
              All employees must comply with internal information security policies and keep
              information secure; and
            </li>
            <li>
              Regularly monitoring and reviewing our practise against our own policies and industry
              best practise.
            </li>
          </ul>
        </Text>
        <Text>
          However, the internet is not in itself a secure environment and we cannot give an absolute
          assurance that your information will be secure at all times. Transmission of Personal
          Information over the Internet is at customers’ own risk and they should only enter, or
          instruct the entering of, Personal Information into the Service within a secure
          environment.
        </Text>
        <br />
        <br />
        <Text>
          We will advise at the first reasonable opportunity upon discovering or being advised of a
          security breach where a customer&lsquo;s Personal Information is lost, stolen, accessed,
          used, disclosed, copied, modified, or disposed of by any unauthorised persons or in any
          unauthorised manner.
        </Text>
        <br />
        <br />
        <Text>
          If our customer is an account holder it is their responsibility to keep their password to
          the Services safe. They should notify us as soon as possible if they become aware of any
          misuse of their password, and immediately change their password within the Service or via
          the “Forgotten Password” process.
        </Text>
      </Grid>

      <Grid item marginBottom={MARGIN_SIZE}>
        <Strong>Who do we disclose your Personal Information to, and why?</Strong>
        <br />
        <Text>Shipeezi only discloses Personal Information in limited circumstances.</Text>
        <br />
        <br />
        <Text>
          Shipeezi may provide customers’ Personal Information, including the commercial terms of
          their use of the Services, to third parties for commercial purposes, where the customer
          has been referred by Shipeezi’s commercial partners to Shipeezi. Customers expressly
          consent to the disclosure of Personal Information to third parties for such purposes.
        </Text>
        <br />
        <br />
        <Text>
          Shipeezi will disclose the Personal Information customers have provided to us to other
          entities only if it is necessary and appropriate to facilitate the purpose for which the
          Personal Information was collected pursuant to this Privacy Policy, including the
          provision of the Services. Customers expressly consent to the disclosure of Personal
          Information to members of Shipeezi and their related bodies corporate.
        </Text>
        <br />
        <br />
        <Text>
          Shipeezi may provide customers’ Personal information to third party service providers who
          assist Shipeezi in providing the Services or to other third parties for related purposes
          such as credit reporting and transaction processing services and customers expressly
          consent to the transfer of Personal Information for such purposes, in each case on a
          worldwide basis.
        </Text>
        <br />
        <br />
        <Text>
          Shipeezi will not otherwise disclose any Personal Information to a third party unless
          customers have provided express consent, or unless Shipeezi is otherwise permitted to
          under Australian privacy legislation. However, customers should be aware that Shipeezi may
          be required to disclose Personal Information without any consent in order to comply with
          any court orders, subpoenas, or other legal process or investigation including by tax
          authorities, if such disclosure is required by law. Where possible and appropriate, we
          will notify customers if we are required by law to disclose any Personal Information.
        </Text>
        <br />
        <br />
        <Text>
          The third parties who host our servers do not control and are not permitted to access or
          use customers’ Personal Information except for the limited purpose of storing the
          information. This means that, for the purposes of Australian privacy legislation and
          Australian users of the Service, Shipeezi does not currently “disclose” Personal
          Information to third parties located overseas.
        </Text>
        <br />
        <br />
        <Text>
          Notwithstanding the paragraphs above, while Shipeezi will take all reasonable steps to
          protect customers’ Personal Information, it should be acknowledged that any overseas
          recipient of Personal Information may not be bound by Australian privacy laws and that
          customers’ consent to Shipeezi’s disclosure of their Personal Information to an overseas
          recipient pursuant to this Privacy Policy means that Shipeezi will not be bound to take
          such steps as are reasonable to ensure that the overseas recipient does not breach
          Australian privacy laws.
        </Text>
        <br />
        <br />
        <Text>
          If the ownership or control of all or part of the business changes, we may transfer your
          Personal Information to the new owner.
        </Text>
      </Grid>

      <Grid item marginBottom={MARGIN_SIZE}>
        <Strong>Do we use your Personal Information for Marketing?</Strong>
        <br />
        <Text>
          We will use your Personal Information to offer you products and services we believe may
          interest you, but we will not do so if you tell us not to.
        </Text>
        <br />
        <br />
        <Text>
          Where you receive electronic marketing communications from us, you may opt-out of
          receiving further marketing communications by following the opt-out instructions provided
          in the communication.
        </Text>
      </Grid>

      <Grid item marginBottom={MARGIN_SIZE}>
        <Strong>Access to and correction of your Personal Information</Strong>
        <br />
        <Text>
          It is the customer&lsquo;s responsibility to ensure that the Personal Information provided
          to us is accurate, complete and up-to-date. Customers may request access to the
          information we hold about themselves, or request that we update, correct or delete any
          Personal Information we hold about them, by setting out a request in writing and sending
          it to us at support@shipeezi.com. Upon receipt of those requests, we may seek information
          from the customer to confirm they are the person to whom the Personal Information relates
          prior to processing their request.
        </Text>
        <br />
        <br />
        <Text>
          Shipeezi will process the request as soon as reasonably practicable, provided we are not
          otherwise prevented from doing so on legal grounds. If we are unable to meet their
          request, we will let them know why. For example, it may be necessary for us to deny a
          request if it would have an unreasonable impact on the privacy or affairs of other
          individuals, or if it is not reasonable and practicable for us to process the request.
        </Text>
        <br />
        <br />
        <Text>
          Customers may also delete their customers’, clients’ or service providers’ information.
          Our Services and related documentation gives the ability to delete certain information
          about them or their customer, client or service provider from within the Service. For
          example, they can remove content that contains information about them using the keyword
          search and editing tools associated with that content and they can remove certain profile
          information within their profile settings. Please note, however, that we may need to
          retain certain information for record keeping purposes, to complete transactions or to
          comply with our legal obligations.
        </Text>
        <br />
        <br />
        <Text>
          We’ll only keep Personal Information for as long as we require it for the purposes of
          providing customers with the Service. However, we may also be required to keep some
          Personal Information for specified periods of time, for example, under certain laws
          relating to corporations, money laundering, and financial reporting legislation.
        </Text>
      </Grid>

      <Grid item marginBottom={MARGIN_SIZE}>
        <Strong>Your rights under the EU GDPR</Strong>
        <br />
        <Text>
          Under the European Union (EU) General Data Protection Regulation (GDPR), as a data subject
          you have the right to:
        </Text>
        <br />
        <br />
        <Text>
          <ul className={classes.tag}>
            <li>access your data;</li>
            <li>have your data deleted or corrected where it is inaccurate;</li>
            <li>object to your data being processed and to restrict processing;</li>
            <li>withdraw consent to having your data processed;</li>
            <li>
              have your data provided in a standard format so that it can be transferred elsewhere;
              and
            </li>
            <li>not be subject to a decision based solely on automated processing.</li>
          </ul>
        </Text>
        <Text>(Data Subject Rights)</Text>
        <br />
        <Text>
          We have processes in place to deal with Data Subject Rights requests. Our actions and
          responsibilities will depend on whether we are the controller or processer of the personal
          data at issue. Depending on our role as either a controller or processor, the process for
          enabling Data Subject Rights may differ, and are always subject to applicable law.
        </Text>
        <br />
        <br />
        <Text>
          Please refer to the Contact Details section of this Privacy Policy if you would like to
          make a Data Subject Rights request.
        </Text>
        <br />
        <br />
        <Text>Customers can opt-out of any email communications</Text>
        <br />
        <br />
        <Text>
          Shipeezi sends billing information, product information, Service updates and Service
          notifications to customers via email. Our emails will contain clear and obvious
          instructions describing how customers can choose to be removed from any mailing list not
          essential to the Service. Shipeezi will remove anyone at their request.
        </Text>
      </Grid>

      <Grid item marginBottom={MARGIN_SIZE}>
        <Strong>You are responsible for transfer of your data to third-party applications</Strong>
        <br />
        <Text>
          A Service may allow customers to transfer data, including their Personal Information,
          electronically to and from third-party applications. Shipeezi has no control over, and
          takes no responsibility for, the privacy practices or content of these applications.
          Customers are responsible for checking the privacy policy of any such applications so that
          they can be informed of how this third-party will handle Personal Information.
        </Text>
      </Grid>

      <Grid item marginBottom={MARGIN_SIZE}>
        <Strong>Contact Details</Strong>
        <br />
        <Text>Shipeezi has a privacy complaints process.</Text>
        <br />
        <br />
        <Text>
          If any customers or browsers wish to complain about how we have handled their Personal
          Information, they can provide our Privacy Officer with full details of their complaint and
          any supporting documentation:
        </Text>
        <br />
        <Text>by email at support@shipeezi.com; or</Text>
        <Text>
          by letter to The Privacy Officer, Shipeezi Pty Ltd, Level 2/11 York Street, Sydney NSW
          2000.
        </Text>
        <br />
        <br />
        <Text>Our Privacy Officer will endeavour to:</Text>
        <br />
        <br />
        <Text>
          <ul className={classes.tag}>
            <li>
              provide an initial response to the query or complaint within 10 business days; and
            </li>
            <li>
              investigate and attempt to resolve the query or complaint within 30 business days or
              such longer period as is necessary and notify them.
            </li>
          </ul>
        </Text>
        <Text>
          If you remain unsatisfied with the way in which we have handled a privacy issue, you may
          approach an independent advisor or contact the Office of the Australian Information
          Commissioner (OAIC) (www.oaic.gov.au) for guidance on alternative courses of action which
          may be available.
        </Text>
      </Grid>

      <Grid item>
        <Strong>Changes to this Privacy Policy</Strong>
        <br />
        <Text>This Privacy Policy may be updated from time to time.</Text>
        <br />
        <br />
        <Text>
          Shipeezi reserves the right to change this Privacy Policy at any time, and any amendments
          to this Privacy Policy is effective upon posting to the Shipeezi website. Shipeezi will
          make every effort to communicate any significant changes to you via email or notification
          via the Services.
        </Text>
        <br />
        <br />
        <Text>
          Your continued use of the Services will be deemed acceptance of any amended Privacy
          Policy.
        </Text>
      </Grid>
    </React.Fragment>
  );
};
